import type { PaymentPlace, TransactionFilterStatus } from "@/modules/finances/types/financesType"

export const financeKeys = {
  all: ["finance"] as const,
  stats: (period: string) => [...financeKeys.all, "stats", period] as const,
  transactionDetails: (transactionId: string) => [...financeKeys.all, "transactionDetails", transactionId] as const,
  transactions: (filters: {
    status: TransactionFilterStatus | undefined
    paymentPlace: PaymentPlace | undefined
    nameFilter: string | undefined
    period: string
    page: number
    pageSize: number
    sortBy: string | undefined
    sortOrder: string | undefined
  }) => [...financeKeys.all, "transactions", filters] as const,
}
